import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { MainService } from './mainservices.model';

@Injectable({
  providedIn: 'root'
})
export class MainserviceService {

  constructor(private http: HttpClient, private global: Globle) {

  }


  getAll(status: boolean) {
    return this.http.get<MainService[]>(this.global.APIURL + "mainservice?status=" + status);
  }

  getById(id: number) {
    return this.http.get<MainService>(this.global.APIURL + "mainservice/" + id);
  }

  Create(mainservice: any) {
    return this.http.post(this.global.APIURL + "mainservice", mainservice)
  }

  Update(mainservice: any) {
    return this.http.put(this.global.APIURL + "mainservice", mainservice)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.global.APIURL + "mainservice/upload", formdata)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "mainservice/" + id)
  }
}
